import { useCallback, useState } from 'react';

export function useRerender() {
  const [, rerender] = useState({});
  return useCallback(() => rerender({}), []);
}
